import {
  ModelSettings
} from '../../models/modelsettings';
import {
  RunService
} from '../../services/service';
import {
  Component, OnInit
} from '@angular/core';

import * as XLSX from 'xlsx';
import {
  Questions
} from '../../models/questions';
type AOA = any[][];

@Component({
  selector: 'app-question-data',
  templateUrl: './question-data.component.html',
  styleUrls: ['./question-data.component.scss']
})
export class QuestionDataComponent implements OnInit {
  files: Array<File> = [];
  stopWordsToUse: string;
  unigram: boolean;
  bigram: boolean;
  trigram: boolean;
  quadgram: boolean;
  majority: boolean;
  weighted: boolean;
  lOne: boolean;
  lTwo: boolean;
  weightedCV: boolean;
  data: AOA = [];
  runIndividual = false;
  isPreview = false;
  isProcess = false;
  isAdvanced = false;
  columns: any[];
  wopts: XLSX.WritingOptions = {
    bookType: 'xlsx',
    type: 'array'
  };
  title = 'AACR Management';
  modelSettings: ModelSettings;

  constructor(private service: RunService) { }

  ngOnInit() {
    this.data = null;
    this.runIndividual = false;
    this.modelSettings = new ModelSettings();
    this.modelSettings.Analytic = true;
    this.modelSettings.UseDefaultStopWords = true;
    this.modelSettings.KeepNumbers = true;
    this.unigram = true;
    this.modelSettings.NgramLength = 1;
    this.majority = true;
    this.modelSettings.EnsemblingMethod = 'Majority';
  }

  onFileChange(evt: any) {
    // tslint:disable-next-line:variable-name
    const _files = evt.target.files;
    this.files = [];
    const len = _files.length;

    for (let i = 0; i < len; ++i) {
      this.files.push(_files[i]);
    }
    /* wire up file reader */
    // tslint:disable-next-line:no-angle-bracket-type-assertion
    const target: DataTransfer = <DataTransfer>(evt.target);
    // tslint:disable-next-line:curly
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {
        type: 'binary'
      });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      // tslint:disable-next-line:no-angle-bracket-type-assertion
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {
        header: 1
      }));
      this.isPreview = true;
    };
    reader.readAsBinaryString(target.files[0]);
  }

  stopWordsClick(button: string) {
    if (button === 'default') {
      this.modelSettings.UseDefaultStopWords = true;
      this.modelSettings.UseCustomStopWords = false;
    }
    if (button === 'no') {
      this.modelSettings.UseDefaultStopWords = false;
      this.modelSettings.UseCustomStopWords = false;
    }
    if (button === 'custom') {
      this.modelSettings.UseDefaultStopWords = null;
      this.modelSettings.UseCustomStopWords = true;
    }
  }

  setTab(tabName) {
    const previewElem: HTMLElement = document.getElementById('preview');
    const processElem: HTMLElement = document.getElementById('process');
    const advancedElem: HTMLElement = document.getElementById('advanced');
    previewElem.className = '';
    processElem.className = '';
    advancedElem.className = '';
    this.isPreview = false;
    this.isProcess = false;
    this.isAdvanced = false;

    if (tabName === 'process') {
      this.isProcess = true;
    }
    if (tabName === 'preview') {
      this.isPreview = true;
    }
    if (tabName === 'advanced') {
      this.isAdvanced = true;
    }

    const tabElement: HTMLElement = document.getElementById(tabName);
    tabElement.className = 'is-active';
  }

  handleType(type: string) {
    this.modelSettings.Analytic = false;
    this.modelSettings.Holistic = false;
    if (type === 'holistic') {
      this.modelSettings.Holistic = true;
    }
    if (type === 'analytic') {
      this.modelSettings.Analytic = true;
    }
  }

  selectModel(model: string) {
    this.modelSettings.Binary = false;
    this.modelSettings.Svm = false;
    this.modelSettings.Lda = false;
    this.modelSettings.Rf = false;
    this.modelSettings.Logit = false;
    this.modelSettings.Maxent = false;
    this.modelSettings.Bagging = false;
    this.modelSettings.Glment = false;
    if (model === 'binary') {
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.Binary = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'binary';
    }
    if (model === 'svm') {
      this.modelSettings.Svm = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'svm';
    }
    if (model === 'lda') {
      this.modelSettings.Lda = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'lda';
    }
    if (model === 'rf') {
      this.modelSettings.Rf = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'rf';
    }
    if (model === 'logit') {
      this.modelSettings.Logit = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'logit';
    }
    if (model === 'maxent') {
      this.modelSettings.Maxent = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.Binary = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'maxemt';
    }
    if (model === 'bag') {
      this.modelSettings.Bagging = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'bagging';
    }
    if (model === 'glment') {
      this.modelSettings.Glment = true;
      this.modelSettings.RunIndividualAlgo = true;
      this.modelSettings.ShowIndividualTables = true;
      this.modelSettings.ShowIndividualAlgoResults = true;
      this.modelSettings.AlgoToRun = 'glment';
    }
  }

  setEnsembleMethod(method: string) {
    this.majority = false;
    this.weighted = false;
    this.lOne = false;
    this.lTwo = false;
    this.weightedCV = false;

    if (method === 'majority') {
      this.majority = true;
      this.modelSettings.EnsemblingMethod = 'Majority';
    }
    if (method === 'weighted') {
      this.weighted = true;
      this.modelSettings.EnsemblingMethod = 'weighted';
    }
    if (method === 'l1') {
      this.lOne = true;
      this.modelSettings.EnsemblingMethod = 'l1';
    }
    if (method === 'l2') {
      this.lTwo = true;
      this.modelSettings.EnsemblingMethod = 'l2';
    }
    if (method === 'weightedcv') {
      this.weightedCV = true;
      this.modelSettings.EnsemblingMethod = 'weightedcv';
    }
  }

  setNgramLength(ngram: string) {
    this.unigram = false;
    this.bigram = false;
    this.trigram = false;
    this.quadgram = false;
    if (ngram === 'uni') {
      this.unigram = true;
      this.modelSettings.NgramLength = 1;
    }
    if (ngram === 'bi') {
      this.bigram = true;
      this.modelSettings.NgramLength = 2;
    }
    if (ngram === 'tri') {
      this.trigram = true;
      this.modelSettings.NgramLength = 3;
    }
    if (ngram === 'quad') {
      this.quadgram = true;
      this.modelSettings.NgramLength = 4;
    }
  }

  runTest() {
    if (this.modelSettings.EmailAddress === undefined || this.modelSettings.EmailAddress == null) {
      window.alert('You must enter an email address');
      return;
    }
    if (this.modelSettings.StudentIdCol === undefined || this.modelSettings.StudentIdCol == null) {
      window.alert('You must enter a student id column');
      return;
    }
    if (this.modelSettings.StudentResponseCol === undefined || this.modelSettings.StudentResponseCol == null) {
      window.alert('You must enter a student response column');
      return;
    }
    if (this.modelSettings.ScoringColumnStart === undefined || this.modelSettings.ScoringColumnStart == null) {
      window.alert('You must enter a scoring column');
      return;
    }
    if (this.modelSettings.NumberOfScoringCols === undefined || this.modelSettings.NumberOfScoringCols == null) {
      window.alert('You must enter the number of bins');
      return;
    }
    if (this.stopWordsToUse !== undefined) {
      this.modelSettings.StopWords = this.stopWordsToUse.split(',', 10000);
    }
    this.files.forEach(file => {
      this.service.runTest(file, this.modelSettings).toPromise().then(r => {
        console.log(r);
      }).catch(e => {
        console.log(e);
      });
      window.alert('Test running, you will receive an email when the test has finished running');
    });
  }



}
